/* eslint func-names: 0 */
// Group language specific content blocks, so we can later ensure at least one
// language is shown for each group
export default function groupLanguageSpecificContent($body) {
  let langContentSetCounter = 0;
  $('div[lang],span[lang],p[lang],h6[lang]').each(function() {
    const $this = $(this);
    if ($this.attr('data-lang-content-group')) return;

    const elementType = $this.prop('tagName');
    langContentSetCounter += 1;
    const parentDefinitionList = $this.parents('dl');
    if (parentDefinitionList.length === 0) {
      $this
        .nextUntil(`*:not(${elementType}[lang])`)
        .addBack()
        .each(function() {
          $(this).attr('data-lang-content-group', langContentSetCounter);
          if ($this.find('dl').length !== 0) {
            $(this).addClass('content-group-with-definition-list');
          }
        });
      return;
    }

    if ($this.siblings('[lang]').length === 0) {
      parentDefinitionList.find(`${elementType}[lang]`).each(function() {
        $(this).attr('data-lang-content-group', langContentSetCounter);
      });
      return;
    }

    $this
      .siblings('[lang]')
      .addBack()
      .each(function() {
        $(this).attr('data-lang-content-group', langContentSetCounter);
      });
  });

  // Save total number of Lang Specific Content Groups to later update them
  // faster
  return $body.data('lang-content-groups-number', langContentSetCounter);
}
